import React, { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axiosInstance from "../../../utils/axiosInstance";
import { queryClient } from "../../..";
import handle401Exception from "../../../utils/handle401Exception";
import { useMutation } from "react-query";
import { GlobalContext } from "../../../utils/GlobalContext";
import { toast } from "react-hot-toast";

function DeleteBookModal({ file_name, book_name, book_id, setDeleteModal }) {
  const { setIsAppLoading } = useContext(GlobalContext);

  const handleClose = () => {
    setIsAppLoading(false);
    setDeleteModal({
      book_id: null,
      book_name: null,
      file_name: null
    });
  };
  // delete question
  const queryFunction = async () => {
    return await axiosInstance
      .delete(`/api/deletebook/${file_name}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          performSideEffects();
        }
      });
  };
  // handle delete  // side effects
  const performSideEffects = () => {
    toast.success(`Book deleted successfully.`);
    queryClient.invalidateQueries({ queryKey: ["get-book-list"] });
    queryClient.invalidateQueries({ queryKey: ["get-audio-book-list"] });
    handleClose();
  };
  const { mutate, isLoading } = useMutation(queryFunction, {
    onError: (error) => {
      if (error?.response.status === 401) {
        handle401Exception(queryFunction, performSideEffects);
      } else {
        handleClose()
      }
    },
  });
  const handleDeleteBook = (e) => {
    e.preventDefault();
    if (!book_id) {
      return;
    }
    mutate();
    // setIsAppLoading(true);
  };
  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Book</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure, you want to delete this book?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            style={{ background: "#EE4B2B", border: "none" }}
            onClick={handleDeleteBook}
          >
            {isLoading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteBookModal;
